/**
 * Selectors for normalized state
 */

// Robot Clients Selectors
export const selectAllRobotClients = (state) => {
  return state.robotClients.allIds.map((id) => state.robotClients.byId[id]);
};

export const selectRobotClientById = (state, robotId) => {
  return state.robotClients.byId[robotId];
};

export const selectRobotClientsCount = (state) => {
  return state.robotClients.allIds.length;
};

export const selectOnlineRobotClients = (state) => {
  return state.robotClients.allIds
    .map((id) => state.robotClients.byId[id])
    .filter((robot) => robot.status === "online");
};

// Robot Groups Selectors
export const selectAllRobotGroups = (state) => {
  return Object.values(state.robotClientGroups);
};

export const selectRobotGroupById = (state, groupId) => {
  return state.robotClientGroups[groupId];
};

// Robots Data Selectors
export const selectAllRobots = (state) => {
  return state.robots.allIds.map((id) => state.robots.byId[id]);
};

export const selectRobotById = (state, robotId) => {
  return state.robots.byId[robotId];
};

export const selectRobotsPagination = (state) => {
  const { page, per_page, total } = state.robots;
  return { page, per_page, total };
};

// Organizations Data Selectors
export const selectAllOrgs = (state) => {
  return state.organizations.allIds.map((id) => state.organizations.byId[id]);
};

export const selectOrgById = (state, orgId) => {
  return state.organizations.byId[orgId];
};

export const selectOrgsPagination = (state) => {
  const { page, per_page, total } = state.organizations;
  return { page, per_page, total };
};

// Advanced Selectors
export const selectRobotsByType = (state, robotType) => {
  return state.robotClients.allIds
    .map((id) => state.robotClients.byId[id])
    .filter((robot) => robot.type === robotType);
};

export const selectRobotsWithCamera = (state) => {
  return state.robotClients.allIds
    .map((id) => state.robotClients.byId[id])
    .filter((robot) => robot.has_camera);
};
